// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const USER_LEVEL = {ADMIN: 2, SUB_ADMIN: 3};
  useEffect(() => {
    const fetchLoginDetails = () => {
      const loginDetails = JSON.parse(localStorage.getItem("login_Details"));
      
      if (loginDetails?.authorisation?.token) {
        setUser({
          role: `${loginDetails?.type}`, // Example role, fetch this dynamically
          user_level: `${loginDetails?.user?.user_level}`,
          category_id: `${loginDetails?.user?.category_id}`
        });
        setUserData(loginDetails?.user)
      }
    };

    fetchLoginDetails(); // Initial fetch

    // Listen for custom login event
    window.addEventListener('login', fetchLoginDetails);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('login', fetchLoginDetails);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, USER_LEVEL,userData }}>
      {children}
    </AuthContext.Provider>
  );
};
